import { CustomerService } from './../../test/customer.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerDao } from 'src/app/test/customer.dao';
import { Customer } from 'src/app/test/customer.model';
import { PropertyType } from 'src/app/product/PropertyType';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'lsu-edit-customer',
  templateUrl: './edit-customer.component.html',
  styleUrls: ['./edit-customer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditCustomerComponent implements OnInit {
  public loading = false
  public formErrors = {
    name: '',
    email: '',
    phone: '',
  }

  propertyTypes : PropertyType[];
  public formGroup: FormGroup;
  constructor(
    public customerService: CustomerService,
    private afs: AngularFirestore, private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditCustomerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Customer
  ) {
    this.propertyTypes = [];
    this.formGroup = this.fb.group({
      _id : this.fb.control(""),
      propertyType : this.fb.control({}),
      name: this.fb.control(""),
      phone: this.fb.control("", [Validators.required, Validators.pattern(/^(?!0+$)(?:\(?\+\d{1,3}\)?[- ]?|0)?\d{10}$/)]),
      email: this.fb.control(""),
      address: this.fb.control(""),
      notes: this.fb.control("")
    });
  }

  // Use getters for cleaner HTML code
  get email() {
    return this.formGroup.get('email')
  }

  get name() {
    return this.formGroup.get('name')
  }
  
  get _id() {
    return this.formGroup.get('_id')
  }

 async ngOnInit() {
    await this.getPropertyTypes()

    if (this.data) {
      const propertyType = this.propertyTypes.find(p => this.data.propertyType.name === p.name)
      this.formGroup.patchValue({
        propertyType,
        _id: this.data._id,
        name: this.data.name,
        phone: this.data.phone,
        email: this.data.email,
        address: this.data.address,
        notes: this.data.notes,
      })
    }
  }

  public async getPropertyTypes(): Promise<void> {
    const querySnapshot = await this.customerService.getPropertyTypes()
    this.propertyTypes = querySnapshot.docs
      .map(doc => ({ name: doc.data().name, id: doc.id }))
  }


  public async updateCustomer(): Promise<void> {
    this.loading = true
    const customer = this.formGroup.value as Customer;
    await this.customerService.updateCustomer(customer, this.data._id)
    this.dialogRef.close({
      ...this.data,
      ...customer,
    })
  }
}